import { type PortableTextComponentProps } from '@portabletext/react'

interface InfoBoxValue {
  title?: string
  content?: string
}

const InfoBox = ({ value }: PortableTextComponentProps<InfoBoxValue>) => {
  const { title, content } = value

  return (
    <div className="info-box bg-green-light text-black rounded-md p-6 sm:p-8">
      {!!title && (
        <h4 className="!mb-4 text-[1.375rem] leading-[1.625rem]">{title}</h4>
      )}

      {!!content && (
        <p
          className="whitespace-pre-wrap !my-0 text-[1.125rem] leading-[1.625rem]"
          dangerouslySetInnerHTML={{
            __html: content,
          }}
        />
      )}
    </div>
  )
}

export default InfoBox
